import React, { useState, useEffect } from 'react';
import request from '../../../request';
import SPBreadcrumb from '../../../components/base/SPBreadcrumb';
import SearchForm from '../../../components/carRental/vehicleManagement/SPSummarySearchForm';
import SPSummaryTable from '../../../components/carRental/vehicleManagement/SPSummaryTable';

interface PagePropsType {
	enums?: any;
	permission?: any;
}
const Page: React.FC<PagePropsType> = props => {
	const { enums } = props;

	return (
		<>
			<SPBreadcrumb title="库存汇总" />
			<SearchForm />
			<SPSummaryTable enums={enums} />
		</>
	);
};

export default Page;
